(function () {
  function init(root) {
    if (!root || root.dataset.lpSizeReady) return;
    root.dataset.lpSizeReady = '1';
    var pills = root.querySelectorAll('[data-size]');
    var cards = root.querySelectorAll('.lp-size__card');
    var cells = root.querySelectorAll('[data-col]');

    function setSize(i) {
      pills.forEach(function (p) { p.setAttribute('aria-checked', String(+p.dataset.size === i)); });
      cards.forEach(function (c) {
        var vals = (c.dataset.values || '').split(',');
        var el = c.querySelector('[data-value]');
        if (!el) return;
        el.textContent = (vals[i] || '').trim();
        el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash');
      });
      cells.forEach(function (c) { c.classList.toggle('is-active', +c.dataset.col === i); });
    }

    function hot(i, on) {
      root.querySelectorAll('[data-measure="' + i + '"]').forEach(function (el) { el.classList.toggle('is-hot', on); });
    }

    pills.forEach(function (p) { p.addEventListener('click', function () { setSize(+p.dataset.size); }); });

    root.querySelectorAll('.lp-size__card, .lp-size__table tbody tr, .lp-size__marker').forEach(function (el) {
      var i = el.dataset.measure;
      el.addEventListener('mouseenter', function () { hot(i, true); });
      el.addEventListener('mouseleave', function () { hot(i, false); });
      el.addEventListener('focus', function () { hot(i, true); });
      el.addEventListener('blur', function () { hot(i, false); });
    });

    root.querySelectorAll('.lp-size__marker').forEach(function (m) {
      m.addEventListener('click', function () {
        var i = m.dataset.measure;
        root.querySelectorAll('.is-hot').forEach(function (el) { el.classList.remove('is-hot'); });
        hot(i, true);
        var card = root.querySelector('.lp-size__card[data-measure="' + i + '"]');
        if (card && window.innerWidth < 900) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { hot(i, false); }, 2200);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-lp-size]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-lp-size]')); });
})();